import { createContext, useContext } from "react";

interface GalleryItemStateProps {
  isActive: boolean;
}

export const GalleryItemState = createContext<GalleryItemStateProps>({ isActive: false });
export const useGalleryItemState = (): GalleryItemStateProps => useContext<GalleryItemStateProps>(GalleryItemState);
